import { render, staticRenderFns } from "./ScanHistory.vue?vue&type=template&id=31cc1a8b&scoped=true"
import script from "./ScanHistory.vue?vue&type=script&lang=js"
export * from "./ScanHistory.vue?vue&type=script&lang=js"
import style0 from "./ScanHistory.vue?vue&type=style&index=0&id=31cc1a8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc1a8b",
  null
  
)

export default component.exports